import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/components/AuthProvider';
import { 
  Home, 
  Search, 
  BarChart3, 
  Briefcase, 
  Settings, 
  FileText,
  ShoppingCart,
  TrendingUp,
  Users,
  Building2,
  TreePine,
  Shield,
  DollarSign
} from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

export function UserNavigation() {
  const { profile } = useAuth();
  const { state } = useSidebar();

  const getNavigationItems = () => {
    const commonItems = [
      { title: 'Dashboard', url: profile?.user_type === 'project_developer' ? '/project-developer' : '/dashboard', icon: Home },
      { title: 'Search Projects', url: '/search', icon: Search },
      { title: 'Marketplace', url: '/marketplace', icon: ShoppingCart },
    ];

    if (profile?.user_type === 'entity') {
      return [
        ...commonItems,
        { title: 'Analytics', url: '/analytics', icon: BarChart3 },
        { title: 'My Portfolio', url: '/portfolio', icon: Briefcase },
        { title: 'ESG Reporting', url: '/esg-reporting', icon: FileText },
        { title: 'Trading History', url: '/trading-history', icon: TrendingUp },
        { title: 'Compliance', url: '/compliance', icon: Shield },
      ];
    } else if (profile?.user_type === 'project_developer') {
      return [
        ...commonItems,
        { title: 'My Projects', url: '/project-projects', icon: TreePine },
        { title: 'Project Registration', url: '/projects/new', icon: Building2 },
        { title: 'Sales & Revenue', url: '/project-sales', icon: DollarSign },
        { title: 'Verification', url: '/project-verification', icon: Shield },
        { title: 'Analytics', url: '/project-analytics', icon: BarChart3 },
      ];
    }

    return [
      ...commonItems,
      { title: 'Analytics', url: '/analytics', icon: BarChart3 },
    ];
  };

  const navigationItems = getNavigationItems();
  const settingsItems = [
    { title: 'Account Settings', url: '/settings', icon: Settings },
    { title: 'Support', url: '/support', icon: Users },
  ];

  return (
    <Sidebar className={state === "collapsed" ? "w-14" : "w-64"} collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navigationItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className={({ isActive }) =>
                        `flex items-center w-full p-2 rounded-lg transition-colors ${
                          isActive
                            ? 'bg-primary text-primary-foreground'
                            : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                        }`
                      }
                    >
                      <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                      {state !== "collapsed" && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupLabel>Settings</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {settingsItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className={({ isActive }) =>
                        `flex items-center w-full p-2 rounded-lg transition-colors ${
                          isActive
                            ? 'bg-primary text-primary-foreground'
                            : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                        }`
                      }
                    >
                      <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                      {state !== "collapsed" && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}